import { render, staticRenderFns } from "./RetencionList.vue?vue&type=template&id=40ca600c"
import script from "./RetencionList.vue?vue&type=script&lang=js"
export * from "./RetencionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports